import React, { useState } from "react";
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";

const IndustryProjects = ({ fetchCourse }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 3;

  const totalProjects = fetchCourse?.courseProject?.length || 0;
  const maxIndex = Math.max(0, totalProjects - itemsPerPage);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, maxIndex));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  return (
    <>
      {fetchCourse && fetchCourse.courseProject.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-left">
          
          <div className="max-w-3xl mb-12">
            <span className="pd-badge mb-4">
              Hands-On Experience
            </span>
            <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
              Industry Projects
            </h2>
            <p className="text-gray-500 text-sm mt-4 leading-relaxed">
              Apply what you learn by working on industry-relevant case studies and practical projects designed by experts.
            </p>
          </div>

          {fetchCourse.courseProject.length > 0 ? (
            <>
              <div className="relative px-8">
                <div className="overflow-hidden">
                  <div
                    className="flex transition-transform duration-500 ease-in-out py-4"
                    style={{ transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)` }}
                  >
                    {fetchCourse.courseProject.map((project) => (
                      <div
                        key={project.id}
                        className="min-w-full sm:min-w-[calc(100%/2)] lg:min-w-[calc(100%/3)] px-3"
                      >
                        <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100/80 h-full flex flex-col justify-between hover:shadow-md hover:-translate-y-1 transition-all duration-300">
                          <div>
                            <span className="text-xs font-black text-blue-600 uppercase tracking-widest bg-blue-50/60 rounded-lg px-2.5 py-1 inline-block mb-4">
                              Project {project.id}
                            </span>
                            <p className="text-gray-600 text-sm leading-relaxed font-semibold">
                              {project.projectDetails?.replace(/<[^>]+>/g, "")}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Arrows */}
                <div className="absolute top-1/2 -translate-y-1/2 left-0 z-10">
                  <button
                    onClick={prevSlide}
                    className="bg-white p-3 rounded-full shadow border border-gray-100 hover:bg-gray-50 transition-colors flex items-center justify-center"
                  >
                    <FaArrowLeftLong className="text-gray-500 hover:text-blue-500" size={16} />
                  </button>
                </div>
                <div className="absolute top-1/2 -translate-y-1/2 right-0 z-10">
                  <button
                    onClick={nextSlide}
                    className="bg-white p-3 rounded-full shadow border border-gray-100 hover:bg-gray-50 transition-colors flex items-center justify-center"
                  >
                    <FaArrowRightLong className="text-gray-500 hover:text-blue-500" size={16} />
                  </button>
                </div>
              </div>

              <div className="flex justify-center mt-8 space-x-2">
                {Array.from({ length: Math.ceil(totalProjects / itemsPerPage) }).map((_, index) => (
                  <div
                    key={index}
                    className={`h-2.5 rounded-full cursor-pointer transition-all duration-300 ${currentIndex === index ? "bg-blue-600 w-6" : "bg-gray-200 w-2.5"
                      }`}
                    onClick={() => setCurrentIndex(index)}
                  ></div>
                ))}
              </div>

              <p className="text-center text-gray-400 mt-8 text-xs font-semibold">
                Disclaimer - The projects have been built leveraging real publicly available datasets from organizations.
              </p>
            </>
          ) : (<h1 className="text-xl font-bold text-center text-gray-500 py-10">
            Not Found Data
          </h1>)}

        </div>
      )}
    </>
  );
};

export default IndustryProjects;
